import { Directive, Input } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { PermissionsInfo } from 'src/app/components/permissions-info';
import { PermissionsService } from 'src/app/services/permissions.service';


@Directive({
    selector: '[permissionCheck]',
    exportAs: 'permissionCheck',
    standalone: false
})
export class PermissionCheckDirective {

  canRead: boolean = false;

  private permissionsSubscription: Subscription;

  constructor(
    private permissionsService: PermissionsService
  ) { }

  ngOnDestroy(): void {
    if (this.permissionsSubscription) {
      this.permissionsSubscription.unsubscribe();
    }
  }

  @Input()
  set permissionCheck(info: PermissionsInfo) {
    if (this.permissionsSubscription) {
      return;
    }

    this.permissionsSubscription = this.permissionsService.getEntityPermissions$(info.areaPermissionKey, info.entityPermissionKey).subscribe(x => {
      this.canRead = x && x.canRead === true;
    });
  }
}
